<template>
 <div>
  <ShortCut></ShortCut>
  <LogoHome></LogoHome>
  <Navigation></Navigation>
  <!--地图定位-->
  <div class="map-class">
      <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:1080px" @click="getClickInfo" :scroll-wheel-zoom='true' v-loading='loadingMap'>
        <bm-view style="width: 100%; height:50%; flex: 1"></bm-view>
        <bm-local-search :keyword="addressKeyword" :auto-viewport="true" style="display: none"></bm-local-search>
      </baidu-map>
  </div>
 </div>
</template>

<script>
import ShortCut from '../component/ShortCut'
import Notice from "../component/Notice";

import Navigation from "../component/Navigation";
import LogoGroup from "../component/LogoGroup";
import LogoHome from "../component/LogoHome";

export default {
  name: "Map"
  ,
  components: {
    ShortCut,
    LogoHome,
    Navigation
  },
  data() {
    return {
      // 地图相关
      loadingMap: true,
      BMap: '',
      map: '',
      geoc: '',
      showMap: true,
      addressKeyword: '',
      pointLngLat: '',
      center: { lng: 117.950756, lat: 36.825744 },
      zoom: 16
    }
  },
  methods: {
    handler ({BMap, map}) {
      this.mapOpen()
      this.BMap = BMap
      this.map = map
      this.loadingMap = true
      var geolocation = new BMap.Geolocation()
      this.geoc = new BMap.Geocoder() // 地址解析对象
      var $this = this
      // 调用百度地图api 中的获取当前位置接口
      geolocation.getCurrentPosition(function (r) {
        let myGeo = new BMap.Geocoder()
        myGeo.getLocation(new BMap.Point(r.point.lng, r.point.lat), function (result) {
          if (result) {
            $this.loadingMap = false
            // console.log("范围信息："+result)
            // $this.$set($this, 'pointLngLat', {lng: result.point.lng, lat: result.point.lat})
            $this.$set($this, 'pointLngLat', {lng: '117.950756',lat: '36.825744'})
            map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放,默认关闭
            $this.addPoint({BMap, map})
          }
        })
      })
    },
    // 添加点位
    addPoint ({BMap, map}) {
      map.clearOverlays()
      var point = new BMap.Point(this.pointLngLat.lng, this.pointLngLat.lat)
      let zoom = map.getZoom()
      // console.log('zoom:' + zoom)
      setTimeout(() => {
        map.centerAndZoom(point, zoom)
      }, 0)
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
    },
    getClickInfo (e) {
      console.log(e)
      this.center = {lng: e.point.lng, lat: e.point.lat}
      this.pointLngLat = {lng: e.point.lng, lat: e.point.lat}
      // 获取点位信息
      let $this = this
      this.geoc.getLocation(e.point, function (rs) {
        var addComp = rs.addressComponents
        $this.pointAddress = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber
        console.log($this.pointAddress)
      })
    },
    // 地图相关
    mapOpen () {
      this.top = this.getScrollTop()
      if (this.top) {
        this.setScrollTop(0)
      }
    },
    checkedAddress(){

    },
// 关闭地图后调用
    closeMap () {
      this.setScrollTop(this.top)
      this.top = 0
      this.showMap = false
    },
    getScrollTop () {
      let scrollTop = 0
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        scrollTop = document.body.scrollTop
      }
      return scrollTop
    },
    setScrollTop (top) {
      if (!isNaN(top)) {
        if (document.documentElement && document.documentElement.scrollTop !== undefined) {
          document.documentElement.scrollTop = top
        } else if (document.body) {
          document.body.scrollTop = top
        }
      }
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Map.vue